import styled from '@emotion/styled';

export const MainContainer = styled.div`
  margin-top: ${props => props.theme.spacing.sm};
`;
